import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { buildGoogleStreetViewEmbedUrl } from "../../../shared/streetView";
import useStreetViewHeading from "../../../shared/hooks/useStreetViewHeading";
import StreetViewIframeTab from "./StreetViewIframeTab";

function StreetViewDialog({ open, onClose, latitude, longitude }) {
  const { t } = useTranslation();
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const heading = useStreetViewHeading({
    open,
    latitude,
    longitude,
    apiKey,
  });

  const embedUrl = buildGoogleStreetViewEmbedUrl({
    latitude,
    longitude,
    apiKey,
    heading,
  });

  return (
    <Dialog
      open={open}
      onClose={(event) => {
        event.stopPropagation();
        onClose();
      }}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { height: "85vh", maxHeight: "85vh", display: "flex" },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          py: 1.5,
          pr: 1,
        }}
      >
        {t("common.streetView")}
        <IconButton aria-label={t("common.close")} onClick={onClose}>
          <CloseIcon
            onClick={(event) => {
              event.stopPropagation();
              onClose();
            }}
          />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          flex: 1,
          minHeight: 0,
          p: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, p: 1, display: "flex" }}>
          <StreetViewIframeTab isActive embedUrl={embedUrl} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={(event) => {
            event.stopPropagation();
            onClose();
          }}
        >
          {t("common.close", { defaultValue: "Close" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StreetViewDialog;
